/**
 * Created by ms on 2017/7/13.
 */


let SOCKETPORT
// let url=window.location.href
let hostname = location.hostname;
// let prefix = '';
if(hostname == 'www.medcircle.cn'){
  // 生产
  SOCKETPORT = '//101.200.192.127:3001/';//生产环境
  console.log('生产环境')
}else{
  SOCKETPORT = '//101.200.192.127:3002/';//测试环境

}
// if(url.includes('www.medcircle.cn')){
//   SOCKETPORT = '//101.200.234.55:3001/';//生产端口
// }else {
//   SOCKETPORT = '//101.200.234.55:3002/';//测试端口
//
// }
export default {
  SOCKETPORT
}



// WEBPACK FOOTER //
// ./src/common/global.js